import { combineReducers } from "redux";
import sideMenu from "./SideMenu";
import activePageIndex from "./ClickedPageIndex";
import registeredCompanies from "./registeredCompanies";
import candidateSetup from "./candidateSetup";
import dashboard from "./dashboard";
import promoCodes from "./promoCodes";
import planCustomization from './subscriptions'
export default combineReducers({
  sideMenu,
  activePageIndex,
  registeredCompanies,
  candidateSetup,
  dashboard,
  promoCodes,
  planCustomization
});
